import {Service} from '@s-ui/domain'

export default class LoginAuthenticationService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {AuthenticationRepository} deps.authenticationRepository
   * @param {CookieAuthenticationRepository} deps.cookieRepository
   * @param {LegacyCookieAuthenticationRepository} deps.legacyCookieRepository
   * @param {UserRepositoryFactory} deps.userRepositoryFactory
   */
  constructor({
    authenticationRepository,
    cookieRepository,
    legacyCookieRepository,
    sessionStorageRepository,
    userRepositoryFactory
  }) {
    super()

    this._authenticationRepository = authenticationRepository
    this._cookieRepository = cookieRepository
    this._legacyCookieRepository = legacyCookieRepository
    this._sessionStorageRepository = sessionStorageRepository
    this._userRepositoryFactory = userRepositoryFactory
  }

  _loggedAction() {
    this._sessionStorageRepository.setLoggedEvent()
  }

  /**
   * @param {Object} params
   * @param {GigyaSignatureEntity} params.gigyaSignatureEntity
   * @return {Promise<void>} The returned promise has failed or is correct without information.
   */
  async execute({gigyaSignatureEntity, suppressVerificationEmail}) {
    const sessionAuthenticationValueObject = await this._authenticationRepository.login({
      gigyaSignatureEntity,
      suppressVerificationEmail
    })

    if (sessionAuthenticationValueObject.getUserData().getContractId()) {
      return sessionAuthenticationValueObject.getUserData()
    } else {
      this._loggedAction()
      const {userData} = await this._cookieRepository.setUserData({
        sessionAuthenticationValueObject
      })

      await this._legacyCookieRepository.setUserData({
        sessionAuthenticationValueObject
      })

      await this._userRepositoryFactory.updateUser(userData)

      return userData
    }
  }
}
